import React from "react";
type CountdownProps = {
  hours: number;
  minutes: number;
  seconds: number;
};
const pad = (n: number) => String(n).padStart(2, "0");
export function Countdown({
  hours,
  minutes,
  seconds
}: CountdownProps) {
  const units = [{
    v: hours,
    l: "Horas"
  }, {
    v: minutes,
    l: "Min"
  }, {
    v: seconds,
    l: "Seg"
  }];
  return <div className="flex items-start justify-center gap-1.5 md:gap-3" role="timer" aria-live="off" data-id="element-81" data-mp="3q02r2f97smiy">
      {units.map((u, i) => <React.Fragment key={u.l} data-id="element-82" data-mp="3c48o0cv4grdr" data-mpi={i}>
          {i > 0 && <span className="pt-2 font-display text-2xl text-gold md:pt-3 md:text-4xl" data-id="element-83" data-mp="3h20fx6vrodhy">:</span>}
          <div className="flex flex-col items-center" data-id="element-84" data-mp="324rn08qtf1o4">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-paper font-display text-2xl tabular-nums text-forest md:h-20 md:w-20 md:rounded-xl md:text-5xl" data-id="element-85" data-mp="3262qs8k9g9f8">
              {pad(u.v)}
            </span>
            <span className="mt-1 text-[10px] font-medium uppercase tracking-wider text-paper/70 md:mt-2 md:text-xs" data-id="element-86" data-mp="15by57nf6gbm0">{u.l}</span>
          </div>
        </React.Fragment>)}
    </div>;
}